import { render, staticRenderFns } from "./GameFinancialMetrics.vue?vue&type=template&id=08394a28"
import script from "./GameFinancialMetrics.vue?vue&type=script&lang=js"
export * from "./GameFinancialMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports